import { IPublicEnumDragObjectType } from '@alilc/lowcode-types';
export function isDragNodeDataObject(obj) {
  return obj && obj.type === IPublicEnumDragObjectType.NodeData;
}